
import Vue from 'vue';
import { ITreeNode } from '../Itree-node';
import { TreeNodeEventType } from '../tree-node-event-type';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VBPopover } from 'bootstrap-vue';

export default Vue.extend({
	components: {
		FontAwesomeIcon
	},
	directives: {
		'b-popover': VBPopover
	},
	props: {
		treeNode: {
			type: Object as () => ITreeNode,
			required: true
		}
	},
	computed: {
		nodeHandleStyle(): string {
			if (this.hasChildren) return this.treeNode.isOpened ? 'opened' : 'closed';
			return 'empty';
		},
		hasChildren(): boolean {
			return this.treeNode.children != null && this.treeNode.children.length > 0;
		}
	},
	methods: {
		nodeHandleClicked(e: MouseEvent) {
			if (this.hasChildren) {
				const node: ITreeNode = this.treeNode;
				e.stopPropagation();
				this.$emit('tree-node-event', { eventType: TreeNodeEventType.NodeHandleClicked, node });
			}
		}
	}
});
